import React from 'react';
import VariablesTable from '../../VariablesPanel/VariablesTable';
import '../styles/variables-block.css';

/**
 * VariablesBlock — in-doc table. New names stay on `doc.variables`.
 * Through a campaign, value edits copy-on-write onto that campaign so two
 * campaigns don't share values. Through a mission, they copy onto that
 * mission instead. The declaration stays doc-scoped.
 */
export const VariablesBlock = ({
  docVariables = [],
  onDocVariablesChange = null,
  onRenameVariable = null,
  variablesHistoryEpoch = 0,
  variableCampaign = null,
  allSprints = [],
  onCampaignVariablesChange = null,
  missionVariables = null,
  onMissionVariablesChange = null,
  onPatchInheritedVariable = null,
  variablesColumnWidths = null,
  onVariablesColumnWidthsChange = null,
}) => {
  const campaignWriter = !!(onCampaignVariablesChange && variableCampaign);
  if (!onDocVariablesChange && !campaignWriter) {
    return (
      <div className="variables-block variables-block--readonly" contentEditable={false}>
        <div className="variables-block__empty">Variables unavailable</div>
      </div>
    );
  }

  return (
    <div className="variables-block" contentEditable={false}>
      <div className="variables-block__label">Variables</div>
      <VariablesTable
        docVariables={docVariables}
        onDocVariablesChange={onDocVariablesChange}
        onRenameVariable={onRenameVariable}
        historyEpoch={variablesHistoryEpoch}
        campaign={variableCampaign}
        onCampaignVariablesChange={
          campaignWriter ? onCampaignVariablesChange : null
        }
        missionVariables={missionVariables}
        onMissionVariablesChange={onMissionVariablesChange}
        onPatchInheritedVariable={onPatchInheritedVariable}
        allSprints={allSprints}
        columnWidths={variablesColumnWidths}
        onColumnWidthsChange={onVariablesColumnWidthsChange}
      />
    </div>
  );
};
